<template>
<div>
  <lottie :options="defaultOptions"/>
</div>
</template>

<script>
import noNotification from '@/assets/animations/no-notification.js'
import Lottie from "vue-lottie";
export default {
  name: "NoNotification",
  components: {
    Lottie
  },
  data() {
    return {
      defaultOptions: {animationData: noNotification, loop: true},
    }
  }
}
</script>

<style scoped>

</style>